import { applyMiddleware, combineReducers, createStore } from "redux";

import { ShipmentByUserReducer } from "../../modules/ntn-consumer/state/reducers/ShipmentByUserReducer";
import { ShipmentReducer } from "../../modules/ntn-consumer/state/reducers/ShipmentReducer";

import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { PortsReducer } from "../../modules/ntn-consumer/state/reducers/PortsReducer";
import { SoldeReducer } from "../../modules/ntn-consumer/state/reducers/SoldeReducer";
import { ShipmentDeleteReducer } from "../../modules/ntn-consumer/state/reducers/ShipmentDeleteReducer";
import { ShipmentRefreshReducer } from "../../modules/ntn-consumer/state/reducers/ShipmentRefreshReducer";

const allReducers = combineReducers({
  ShipmentReducer,
  ShipmentByUserReducer,
  PortsReducer,
  ShipmentDeleteReducer,
  ShipmentRefreshReducer,
  SoldeReducer,
});
const store = createStore(
  allReducers,
  composeWithDevTools(applyMiddleware(thunk))
);

export default store;
